<template>
  <div id="app">
	<Header></Header>
	<transition name="fade" mode="out-in"></transition>
    <!-- 设置路由挂载点 -->
    <router-view></router-view>
	<Footer></Footer>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {}
}
</script>

<style>
	@import './static/css/bootstrap.css';
	body {
		margin: 0;
		background-color: #F5F5F5;
	}
	p {
		margin: 0;
	}
	.container-wrap {
		width: 1200px;
		margin: 0 auto;
	}
	a:-webkit-any-link {
		text-decoration: none;
	}
	a{
		text-decoration:none !important;
	}
@media (min-width: 640px) and (max-width: 1200px) { 
		.container-wrap{
			width: 100%;
		}
		
	}
@media  (max-width: 640px) { 
		.container-wrap{
			width: 100%;
			}
	}
</style>
